import { Avatar, type AvatarSize } from "./Avatar.tsx"

export type ArtistAvatarProps = {
  url?: string
  name: string
  size: AvatarSize
}

export const ArtistAvatar = ({ url, name, size }: ArtistAvatarProps) => {
  return <Avatar src={url} kind="square" size={size} displayName={name} />
}
